export default "__VITE_ASSET__Cq30M3mV__"